export default __webpack_public_path__ + "static/ornament-6636e4150bf536564e0acd88958e788f.jpg";